import { FilterPageApi } from '@core/services/http-params/model/api-http-params.model';

export interface PaginatorInput {
  pageIndex: number;
  pageSize: number;
}

export const pagingDomainToApi = (domain: PaginatorInput): FilterPageApi => ({
  pageNumber: domain.pageIndex,
  numOfElements: domain.pageSize,
});
